import { Stack, Typography } from '@deltasierra/react-components-core';
import { Folder } from '@deltasierra/react-icons';

type AssetLibraryGalleryGridItemFolderProps = {
    folderName: string;
    height: number;
    width: number;
};

export const AssetLibraryGalleryGridItemFolder = ({
    folderName,
    height,
    width,
}: AssetLibraryGalleryGridItemFolderProps): JSX.Element => (
    <Stack
        sx={{
            alignItems: 'center',
            backgroundColor: 'grey.100',
            borderRadius: 1,
            color: 'primary.main',
            display: 'flex',
            height,
            justifyContent: 'center',
            path: { strokeWidth: 1 },
            width,
        }}
    >
        <Folder height={80} width={80} />
        <Typography
            sx={{
                maxWidth: '80%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            }}
            variant="body1"
        >
            {folderName}
        </Typography>
    </Stack>
);

AssetLibraryGalleryGridItemFolder.displayName = 'AssetLibraryGalleryGridItemFolder';
